import $ from 'jquery';

const defaults = {
  events: 'click',
  className: 'expanded',
  trigger: '.node-header a',
};

export default class Expanded {
  constructor(element, options) {
    this.$element = $(element);
    this.settings = Object.assign(defaults, options);
    this.update = this.update.bind(this);
    this.listen();
  }

  listen() {
    this.$element.find(this.settings.trigger).bind(this.settings.events, this.update);
  }

  update(event) {
    event.preventDefault(); // prevent native behavior
    const state = this.$element.hasClass(this.settings.className) ? 'remove' : 'add';
    this.$element[`${state}Class`](this.settings.className);
  }
}



// WEBPACK FOOTER //
// ./Expanded.js